import './index.scss';

/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-new */
/* eslint-disable jsdoc/check-line-alignment */
/* eslint-disable jsdoc/check-tag-names */
/* eslint-disable jsdoc/require-param */
/* eslint-disable import/no-unresolved */
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';


(function () {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	const blockClass = 'wp-block-apk-realisations';

	function initGallery(blockImagesGallery) {

		const glightboxBtn = blockImagesGallery.querySelector('.glightbox');
		if (glightboxBtn) {
			GLightbox({
				selector: '.glightbox',
				autoplayVideos: true,
				touchNavigation: true,
			});

			const videoBtns = blockImagesGallery.querySelectorAll('.glightbox-video');
			videoBtns.forEach((btn) => {
				btn.addEventListener('click', () => {
					GLightbox({
						elements: [
							{
								href: btn.dataset.source,
								type: 'video',
								autoplayVideos: true,
							},
						],
					}).open();
				});
			});
		}

	}

	/**
	 * Initialize each block on page load (front end).
	 */
	document.addEventListener('DOMContentLoaded', () => {
		document
			.querySelectorAll(`.${blockClass}`)
			.forEach((blockImagesGallery) => {
				initGallery(blockImagesGallery);
			});
	});

	/**
	 * Initialize dynamic block preview (editor).
	 */
	const initializeBlock = function ($block) {
		const blockImagesGallery = $block[0].querySelector(
			`.${blockClass}`
		);

		if (blockImagesGallery) {
			initGallery(blockImagesGallery);
		}
	};

	if (window.acf) {
		window.acf.addAction(
			`render_block_preview/type=${blockClass}`,
			initializeBlock
		);
	}
})();
